import {pulseUserAtom} from 'atoms/auth';
import {loggedInEmployeeAtom} from 'atoms/employee';
import {WorkstreamEdit} from 'client';
import {PageSpinner} from 'components/shared/PageSpinner';
import {isUserAdmin} from 'helpers/utils';
import {useAtomValue} from 'jotai';
import {NotFound} from 'pages/NotFound';
import {useParams} from 'react-router';

import {useWorkstream, useWorkstreamEdit} from './hooks';
import {isRestrictedWorkstreamAccessResponse, isWorkstreamStatusArchived} from './utils';
import {WorkstreamAccessRequest} from './WorkstreamAccessRequest';
import {WorkstreamModify} from './WorkstreamModify';

export const WorkstreamEditor = () => {
  const params = useParams();
  let workstreamId: number | string = parseInt(params.id ?? '', 10);
  if (isNaN(workstreamId)) {
    workstreamId = params.id ?? '';
  }
  const {workstream, isPending} = useWorkstream(workstreamId);

  const {editWorkstream, isPending: isSaving} = useWorkstreamEdit();

  const {employee} = useAtomValue(loggedInEmployeeAtom);
  const pulseUser = useAtomValue(pulseUserAtom);

  if (!employee.ldap || isPending) {
    return <PageSpinner />;
  }

  if (!workstream) {
    return <NotFound />;
  }

  if (isWorkstreamStatusArchived(workstream) && !isUserAdmin(pulseUser)) {
    return <NotFound />;
  }

  if (isRestrictedWorkstreamAccessResponse(workstream)) {
    return (
      <WorkstreamAccessRequest
        requested={workstream.requested ?? false}
        workstreamId={workstream.id}
      />
    );
  }

  return (
    <WorkstreamModify
      isEditing
      onSubmit={(data) => editWorkstream({data: data.data as WorkstreamEdit, reason: data.reason})}
      isPending={isSaving}
      workstream={workstream}
      disableModifyOutcomes
    />
  );
};
